<template>
<CaseSummaryContainer :loading="isLoading">
  <Header slot="header" :heading="'Case Summaries'" :methodology="methodology" @print="print"></Header>
  <CaseBlockFilter slot="caseBlockFilter" v-show="filterValues" :cases="cases" :filterValues="filterValues" @applyFilter="applyFilter"></CaseBlockFilter>
  <PrintArea slot="printArea" :filteredCases="cases" :reportFilter="reportFilter" />
  <CaseBlock slot="caseBlock" v-if="cases.length" v-for="oigCase in cases" v-bind:key="oigCase.id" :oigCase="oigCase"></CaseBlock>
  <b-jumbotron fluid class="text-center" slot="caseBlock" v-show="typeof cases != 'undefined' && !cases.length">There are no cases which match your selected filters.</b-jumbotron>
</CaseSummaryContainer>
</template>
<!-- Global site tag (gtag.js) - Google Analytics -->
<script async src="https://www.googletagmanager.com/gtag/js?id=UA-142178256-1"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'UA-142178256-1');
</script>
<script>
import CaseSummaryContainer from '@/components/CaseSummaryContainer.vue'
import Header from '@/components/Header'
import CaseBlockFilter from '@/components/DMU/CaseSummaries/CaseBlockFilter'
export default {
  name: 'app',
  components: {
    CaseBlockFilter,
    CaseBlock: () => import( /* webpackChunkName: 'dmuCaseBlock' */ '@/components/DMU/CaseSummaries/CaseBlock'),
    Header,
    CaseSummaryContainer,
    PrintArea: () => import( /* webpackChunkName: 'dmuPrintArea' */ '@/components/DMU/CaseSummaries/PrintArea.vue')
  },
  data() {
    return {
      isLoading: false,
      filter: {},
      methodology: '<p>The OIG monitors the internal investigations and employee disciplinary process of the California Department of Corrections and Rehabilitation. OIG attorneys monitored the cases and determined an overall rating for each case they monitored. As to  each case, the OIG attorneys also assessed the department\'s performance as to six performance indicators which apply to different departmental units and to different phases of the cases.</p><p>Indicator 1 pertains to our assessment of the hiring authorities\' discovery and referral of employee misconduct allegations. In Indicator 2, we assessed the Office of Internal Affairs\' assessment of the analysis and processing of the hiring  authority misconduct referrals. As to Indicator 3, we assessed the Office of Internal Affairs\' performance in conducting internal investigations. In Indicator 4, we evaluated the hiring authorities\' performance in making investigative and  disciplinary findings and the processing of the disciplinary cases. Pursuant to Indicator 5, we assessed the department attorneys\' advice to the Office of Internal Affairs. In Indicator 6, we evaluated the performance of department advocates  (either department attorneys or employee relations officers) in representing the department in employee-misconduct related litigation.</p><p>For each of the cases we monitored and closed, OIG attorneys rated each of the six indicators as either superior, satisfactory, or poor based on collective answers to questions for each indicator. Then, using the same descriptors, OIG attorneys  determined an overall rating for each case. The case summaries include, for each case, an overall rating; a rating for the applicable indicators for each case; and information regarding the answers to the questions for each of the indicators.</p>'
    }
  },
  created() {
    //this.$store.dispatch('dmu/getCases')
    this.$store.dispatch('dmu/getFilterValues')
  },
  methods: {
    applyFilter: function (filter) {
      this.isLoading = true
      return this.$store.dispatch('dmu/setFilter', filter).then(() => {
        return this.$store.dispatch('dmu/getCases').then(() => {
          this.isLoading = false
        })
      })
      // this.filter = filter
    },
    sortCases: function (a, b) {
      if (Date.parse(a.date) > Date.parse(b.date)) return 1
      if (Date.parse(a.date) < Date.parse(b.date)) return -1
      return 0
    },
    displayFormat: function (text) {
      text = text.replace(/([A-Z])/g, ' $1')
      text = text.charAt(0)
        .toUpperCase() + text.slice(1)
      return text
    },
    convertValue: function (label, value) {
      let displayValues = []
      if (label === 'reportingPeriod') {
        value.forEach((x, y) => {
          this.data.reportingPeriods.filter(r => {
            if (r.value === x) displayValues[y] = r.text
          })
        })
        return displayValues.join(', ')
      } else {
        return value.join(', ')
      }
    },
    print: function () {
      window.print()
    }
  },
  computed: {
    cases() {
      return this.$store.state.dmu.cases
    },
    filterValues() {
      return this.$store.getters['dmu/filterValues']
    },
    reportFilter: function () {
      let tempFilter = {}
      let filter = this.$store.state.dmu.filter
      if (Object.keys(filter).length === 0) return tempFilter
      Object.keys(filter)
        .forEach((key) => {
          if (filter[key] != null && filter[key].length) {
            tempFilter[key] = filter[key]
          }
        })
      return tempFilter
    }
  }

}
</script>

<style>
</style>
